// @ts-nocheck
import React from 'react';
import styled, { css } from 'styled-components';
import {
  variant,
  color,
  space,
  layout,
  flexbox,
  typography,
  TypographyProps,
  SpaceProps,
  ColorProps,
  LayoutProps,
  FlexboxProps
} from 'styled-system';
import KompisText from '@inter-ikea-kompis/react-components/lib/KompisText.js';
import { ThemeFontStyleTypeEnum } from '@inter-ikea-kompis/enums/lib';
import { SkapaTheme } from '@inter-ikea-kompis/themes';

// @see https://fundament.ikea.com/foundation/typography#typeStyles
type Type =
  | ThemeFontStyleTypeEnum.headingXSmall
  | ThemeFontStyleTypeEnum.headingSmall
  | ThemeFontStyleTypeEnum.headingMedium
  | ThemeFontStyleTypeEnum.headingLarge
  | ThemeFontStyleTypeEnum.headingXLarge;

export enum HeadingType {
  HeadingOne = 'h1',
  HeadingTwo = 'h2',
  HeadingThree = 'h3',
  HeadingFour = 'h4'
}

const headingSharedCss = css`
  word-break: break-word;
  margin: 0;
  ${color};
  ${space};
  ${typography};
  ${layout}
  ${flexbox}
  ${variant({
    variants: {
      title60: {
        lineHeight: 'narrow'
      },
      title48: {
        lineHeight: 'narrow'
      },
      title38: {
        lineHeight: 'shorter'
      },
      title30: {
        lineHeight: 'short'
      },
      title24: {
        lineHeight: 'short'
      }
    }
  })}
`;

const Heading = styled.h2`
  ${headingSharedCss}
`;

type AsProps = {
  as?: keyof JSX.IntrinsicElements | React.ComponentType<any>;
  forwardedAs?: keyof JSX.IntrinsicElements | React.ComponentType<any>;
};

type ExtendProps = React.PropsWithoutRef<
  React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement>
> &
  SpaceProps &
  ColorProps &
  TypographyProps &
  LayoutProps &
  FlexboxProps &
  AsProps;

export interface TitleProps extends ExtendProps {
  /** Type of title as described in Fundament */
  type: Type;
  /** React element, text, or fragment */
  heading?: HeadingType;
  children: React.ReactNode;
  color?: string;
}

const Title = ({
  type,
  heading = HeadingType.HeadingTwo,
  children,
  color = 'text',
  ...props
}: TitleProps) => {
  return (
    <Heading as={heading} variant={type} {...props} color={color}>
      <KompisText type={type} style={props.style} theme={SkapaTheme}>
        {children}
      </KompisText>
    </Heading>
  );
};

export default Title;
